import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
export class SearchFilterPipe implements PipeTransform {

  transform(items: any[], searchText: string, nameTransformFunction = null): any[] {
    if(searchText){
      searchText = searchText.toLowerCase();
    }

      if(!items || !searchText){
        return items;
      }
      return items.filter(item => {
        if(nameTransformFunction){
          return nameTransformFunction(item).toLowerCase().includes(searchText)
        }
        return item.description? (item.description && item.description.toLowerCase().includes(searchText)) : item.name ? item.name.toLowerCase().includes(searchText): item.toLowerCase().includes(searchText) ;
      })
   }

}
